import NProgress from 'nprogress'

export default function RouterConfig (router, options) {
  router.beforeEach((to, from, next) => {
    NProgress.start()
    document.title = to.meta.title
    next()
  })

  router.afterEach((to) => {
    const { name } = to
    if (options.noAfterRouteIsLoading.indexOf(name) === -1) {
      setTimeout(() => {
        NProgress.done()
      }, 10)
    }
  })
}
